<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-lg-12 text-end">
          <v-btn color="success darken-2" text small @click="openNewWarehouseDialog()"
          ><v-icon small left>mdi-plus</v-icon> Depo Ekle</v-btn
          >
        </div>
      </div>
      <div class="row">
        <ResultTableView
            :perPage="perPage"
            :currentPage="currentPage"
        ></ResultTableView>
      </div>
      <!-- end row -->
    </div>

    <EditWarehouseDialog
        :warehouseProp="warehouseProp"
        :processType="'new'"
        :showDialog="newWarehouseDialog"
        @dialogChange="(data) => (newWarehouseDialog = data)"
    >

    </EditWarehouseDialog>
  </div>
</template>

<script>

import {mapActions, mapState} from "vuex";
import ResultTableView from "@/components/management/warehouse-management/results/ResultsTableView.vue";
import EditWarehouseDialog from "@/components/management/warehouse-management/dialogs/EditWarehouseDialog.vue";

export default {
  name: "Results.vue",
  components: {ResultTableView, EditWarehouseDialog},
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      warehouseProp: null,
      newWarehouseDialog: false,
    }
  },
  methods: {
    ...mapActions('company', ["fetchCompanyWarehouseList","deleteCompanyWarehouse"]),
    openNewWarehouseDialog() {
      this.newWarehouseDialog = true;
    }
  },
  computed: {
    ...mapState('company', ['companyWarehouseList','companyWarehouseListLoading','companyWarehouseListHeaders'])
  },
  mounted() {
    this.fetchCompanyWarehouseList({
      params:{
      },
      body:{

      },
    })
  }
}
</script>


<style scoped>

</style>